/**
 * 瀑布流组件（绝对定位实现)
 * @author VenDream
 * @since 17/12/11
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './waterfall.less';

// 常规H5作品的宽高比
const RATIO = 320 / 504;

class Waterfall extends Component {
  static propTypes = {
    items: PropTypes.array, // 瀑布流元素
    classname: PropTypes.string, // 自定义类名
    column: PropTypes.number, // 瀑布流列数
    gutter: PropTypes.number, // 元素间隙
  };

  static defaultProps = {
    items: [],
    classname: '',
    column: 2,
    gutter: 10,
  };

  constructor(props) {
    super(props);

    const { column, gutter } = props;
    this.waterfall = { column, gutter, columns: {} };
  }

  componentDidMount() {
    this.root && this.forceUpdate();
  }

  componentDidUpdate() {
    this.updateGridHeiht();
  }

  getWaterfall() {
    const waterfall = [];
    const { items, column, gutter } = this.props;

    if (!this.root || !this.root.parentNode) return null;

    // 清空原来的瀑布流对象
    this.waterfall = { column, gutter, columns: {} };
    // 计算瀑布流总宽度
    const containerWidth = this.root.getBoundingClientRect().width;
    // 计算瀑布流元素宽度
    const itemWidth = Math.floor(
      (containerWidth - (column - 1) * gutter) / column
    );

    // 初始化瀑布流对象
    for (let i = 0; i < column; i += 1) {
      this.waterfall.columns[`column_${i}`] = {
        name: `column_${i}`,
        x: i * (itemWidth + gutter),
        h: 0,
        items: [],
      };
    }

    // 构筑瀑布流
    for (const [i, item] of Object.entries(items)) {
      const shortestCol = this.findColumnOf('shortest');
      const w = itemWidth;
      const h = item.height || w / RATIO + 90; // 这里主要是针对模板市场的盒子高度
      const g = shortestCol.h === 0 ? 0 : gutter;
      const y = shortestCol.h + g;
      const x = shortestCol.x;

      // 计算每一项的样式
      const style = {
        top: `${y}px`,
        left: `${x}px`,
        width: `${w}px`,
        height: `${h}px`,
      };

      // 添加到瀑布流
      waterfall.push(
        <div className="waterfall-item" style={style} key={i}>
          {item.content ? item.content : item}
        </div>
      );

      // 更新最短列元素及高度
      shortestCol.items.push(item);
      shortestCol.h += h + g;
    }

    return (
      <div className="waterfall-grid" ref={node => (this.grid = node)}>
        {waterfall}
      </div>
    );
  }

  // 寻找最短列或最长列
  findColumnOf(type = 'shortest') {
    const { column, columns } = this.waterfall;
    let targetCol = columns['column_0'];

    for (let i = 0; i < column; i += 1) {
      const col = columns[`column_${i}`];
      const conditon =
        type === 'shortest' ? col.h < targetCol.h : col.h > targetCol.h;

      conditon && (targetCol = col);
    }

    return targetCol;
  }

  // 更新瀑布流高度
  updateGridHeiht() {
    const longestCol = this.findColumnOf('longest');
    this.grid.style.height = `${longestCol.h}px`;
  }

  render() {
    return (
      <div className="cmp waterfall" ref={node => (this.root = node)}>
        {this.getWaterfall()}
      </div>
    );
  }
}

export default Waterfall;
